import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../../hooks/auth/useAuth';
import { useSubscription } from '../../hooks/subscriptions/useSubscription';
import { LoadingScreen } from '../common/LoadingScreen';
import { UpgradePrompt } from './UpgradePrompt';

interface ProtectedRouteProps {
  children: React.ReactNode;
  requiresSubscription?: boolean;
  requiresAdmin?: boolean;
}

export function ProtectedRoute({ 
  children, 
  requiresSubscription = false,
  requiresAdmin = false 
}: ProtectedRouteProps) {
  const location = useLocation();
  const { isAuthenticated, isAdmin, isLoading: authLoading } = useAuth();
  const { subscription, isLoading: subscriptionLoading, isPro } = useSubscription();
  
  if (authLoading || (requiresSubscription && subscriptionLoading)) {
    return <LoadingScreen />;
  }

  if (!isAuthenticated) {
    return <Navigate to="/login" state={{ from: location.pathname }} replace />;
  }

  if (requiresAdmin && !isAdmin) {
    return <Navigate to="/dashboard" replace />;
  }

  if (requiresSubscription && !isAdmin) {
    // Simple console log for debugging
    console.log('Subscription state:', { subscription, isPro });
    
    if (!isPro) {
      return <UpgradePrompt 
        feature={location.pathname === '/jobs' ? 'job board' : 'resume reviews'} 
      />;
    }
  }

  return <>{children}</>;
}